//@ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import AccessScopes from "lib/constants/AccessScopes";
import { Text } from "components/Typography";
import { SelectInput } from "../../Input";

class SelectAccessScope extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    appearance: PropTypes.oneOf(["normal", "inline"]),
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    appearance: "normal",
    placeholder: "Select access scope",
    autoFocus: false,
    disabled: false,
  };

  render() {
    const { name, value, onChange, placeholder, appearance, className, autoFocus, disabled } = this.props;
    const input = {
      type: "select",
      name,
      placeholder: placeholder,
      options: AccessScopes.items,
      autoFocus,
      disabled,
    };

    return appearance === "inline" ? (
      <Text
        value={value}
        canEdit={true}
        input={input}
        onConfirm={(value) => onChange(name, value)}
        className={className}
      />
    ) : (
      <SelectInput input={input} value={value} onChange={onChange} className={className} />
    );
  }
}

export default SelectAccessScope;
